let pageBack = () => {
  return {
      restrict: 'A',
      scope: true,
      link: function($scope, elem, attrs) {
          elem.on('click', function() {
              window.history.back();
          });
      }
  };
};

pageBack.$inject = [];

export default pageBack;



// WEBPACK FOOTER //
// ./client/app/common/directives/page-back.js